import script from "./VueDataTablePaginator.vue?vue&type=script&setup=true&lang=js"
export * from "./VueDataTablePaginator.vue?vue&type=script&setup=true&lang=js"

import "./VueDataTablePaginator.vue?vue&type=style&index=0&id=3548ac04&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3548ac04"]])

export default __exports__